__turbopack_context__.v({
  "className": "caveat_6f3ce787-module__p9ZrNG__className",
});
